var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnviroment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_220_1844",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_220_1844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.81482 1.03474C7.361 1.48067 6.68357 2.67984 6.60107 4.21047H7.81482V1.03474Z",
    fill: "#0B5838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42676 4.82251V7.99823C8.88057 7.5523 9.558 6.35314 9.6405 4.82251H8.42676Z",
    fill: "#0B5838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2527 4.2104H11.778C11.7158 3.47626 11.4345 2.77771 10.9706 2.20527C10.5067 1.63286 9.88162 1.21294 9.17627 1C9.7242 1.74624 10.1869 2.94674 10.2527 4.21037L10.2527 4.2104Z",
    fill: "#0B5838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81482 7.99823V4.82251H6.60107C6.68357 6.35326 7.36099 7.55225 7.81482 7.99823Z",
    fill: "#0B5838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98923 4.82251H4.46387C4.52613 5.55666 4.8074 6.2552 5.27127 6.82764C5.73518 7.40006 6.36029 7.81993 7.06559 8.03291C6.51766 7.28672 6.05509 6.08618 5.98915 4.82255L5.98923 4.82251Z",
    fill: "#0B5838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2527 4.8225C10.1869 6.08613 9.7242 7.28659 9.17632 8.03287H9.17627C9.88162 7.81988 10.5067 7.40001 10.9706 6.8276C11.4345 6.25518 11.7157 5.55662 11.778 4.82246L10.2527 4.8225Z",
    fill: "#0B5838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42676 1.03474V4.21047H9.6405C9.55801 2.67971 8.88058 1.48072 8.42676 1.03474Z",
    fill: "#0B5838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9892 4.21041C6.055 2.94678 6.51771 1.74632 7.0656 1.00005H7.06564C6.36029 1.213 5.73517 1.6329 5.27132 2.20532C4.8074 2.77768 4.52613 3.47629 4.46387 4.21045L5.9892 4.21041Z",
    fill: "#0B5838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24619 10.5545L6.9016 10.1911C6.90065 10.1901 6.89931 10.1897 6.8984 10.1888C6.89744 10.1878 6.89701 10.1861 6.89591 10.1851L5.3812 8.66976C5.22636 8.51592 5.00127 8.45619 4.79052 8.513C4.57972 8.56976 4.41513 8.73446 4.35851 8.94529C4.30184 9.15609 4.36176 9.38109 4.51565 9.53587L4.51196 9.53425L5.39525 10.4176C5.45398 10.4747 5.48736 10.553 5.48793 10.6349C5.48851 10.7168 5.45623 10.7956 5.39832 10.8535C5.3404 10.9114 5.26169 10.9437 5.17977 10.9431C5.09785 10.9425 5.01957 10.9091 4.96247 10.8504L3.22422 9.10727V6.9649C3.22422 6.74622 3.10754 6.54413 2.91817 6.43481C2.72879 6.32544 2.49543 6.32544 2.30606 6.43481C2.11669 6.54413 2.00001 6.74622 2.00001 6.9649V9.82135C1.99886 10.0903 2.11659 10.346 2.32161 10.5201L5.06053 13.2216V14.0041C5.06048 14.0852 5.09272 14.1631 5.1501 14.2205C5.20753 14.2779 5.28539 14.3102 5.36659 14.3101H7.2029C7.2841 14.3102 7.36195 14.2779 7.41939 14.2205C7.47678 14.1631 7.50901 14.0852 7.50896 14.0041V11.1965C7.50896 10.9563 7.41461 10.7257 7.24623 10.5544L7.24619 10.5545Z",
    fill: "#0B5838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99568 10.5545L9.34027 10.1911C9.34122 10.1901 9.34251 10.1897 9.34347 10.1888C9.34443 10.1878 9.34486 10.1861 9.34596 10.1851L10.8607 8.66975C10.9754 8.5544 11.1313 8.48942 11.294 8.48922C11.4567 8.48903 11.6128 8.55364 11.7279 8.66869C11.8429 8.7838 11.9073 8.93993 11.907 9.10261C11.9067 9.2653 11.8417 9.42119 11.7262 9.53587L11.7299 9.53425L10.8466 10.4176C10.7879 10.4747 10.7545 10.553 10.7539 10.6349C10.7534 10.7168 10.7856 10.7956 10.8436 10.8535C10.9015 10.9114 10.9802 10.9437 11.0621 10.9431C11.144 10.9425 11.2223 10.9091 11.2794 10.8504L13.0177 9.10727V6.9649C13.0177 6.74622 13.1343 6.54413 13.3237 6.43481C13.5131 6.32544 13.7464 6.32544 13.9358 6.43481C14.1252 6.54413 14.2419 6.74622 14.2419 6.9649V9.82135C14.243 10.0903 14.1253 10.346 13.9203 10.5201L11.1813 13.2216V14.0041C11.1814 14.0852 11.1492 14.1631 11.0918 14.2205C11.0343 14.2779 10.9565 14.3102 10.8753 14.3101H9.03897C8.95777 14.3102 8.87992 14.2779 8.82248 14.2205C8.76509 14.1631 8.73286 14.0852 8.73291 14.0041V11.1965C8.73291 10.9563 8.82726 10.7257 8.99564 10.5544L8.99568 10.5545Z",
    fill: "#0B5838"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnviroment);
export default __webpack_public_path__ + "static/media/Enviroment.361e6c648222ee3c32228dfeb4567407.svg";
export { ForwardRef as ReactComponent };